<script setup>
import { watch, ref, onMounted } from 'vue';

const props = defineProps({
    steps: {
        type: Array,
        required: true
    },
    stepCount: {
        type: Number,
        required: true
    }
});
const list = ref(null);

const scrollToStep = (index) => {
    const el = list.value.querySelector('li:nth-child(' + (index) + '');
    el.scrollIntoView({ behavior: "smooth", inline: "end"});
}

onMounted(() => {
    scrollToStep(1);
});

watch(() => props.stepCount, (newCount) => {
    scrollToStep(newCount + 1);
})
</script>

<template>
    <div class="tw-bg-black tw-text-white">
        <ol
            ref="list"
            class="container scrollbar-hide tw-flex lg:tw-justify-center tw-w-full tw-list-none tw-pt-5 tw-border-black tw-overflow-scroll tw-scroll-mb-[100px]"
        >
            <li v-for="(step, i) in steps" :key="step" class="tw-whitespace-nowrap" :class="i + 1 === steps.length && 'tw-pr-2'">
                <a
                    :class="stepCount >= i ? 'tw-border-b-4 tw-border-pink-500' : 'tw-opacity-50'"
                    class="tw-inline-block tw-pb-3 tw-font-secondary tw-font-medium tw-text-sm tw-cursor-pointer"
                    tabindex="0"
                    @click="i < stepCount && $emit('step', i)"
                >
                    {{ i + 1 }}. {{ step.label }}
                </a>
                <svg
                    v-if="i !== steps.length - 1"
                    id="Flat"
                    class="tw-inline-block tw-mx-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#fff"
                    width="15px"
                    height="15px"
                    viewBox="0 0 256 256"
                >
                    <path
                        d="M96,220a12,12,0,0,1-8.48535-20.48535L159.0293,128,87.51465,56.48535a12.0001,12.0001,0,0,1,16.9707-16.9707l80,80a12.00062,12.00062,0,0,1,0,16.9707l-80,80A11.96287,11.96287,0,0,1,96,220Z"
                    />
                </svg>
            </li>
        </ol>
    </div>
</template>
<style scoped>
    .scrollbar-hide::-webkit-scrollbar {
        display: none;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
</style>
